import React from 'react';
import { TextV2 } from '@withjoy/joykit';

interface ComponentSectionHeaderProps
  extends Readonly<{
    title: string;
  }> {}

export const ComponentSectionHeader: React.FC<ComponentSectionHeaderProps> = ({ title }) => {
  return (
    <TextV2
      typographyVariant="label2"
      color="mono8"
      fontWeight={500}
      paddingTop={6}
      paddingBottom={3}
    >
      {title}
    </TextV2>
  );
};
